const videoPlayerEvents = {
  VIEW_PAGE_EVENT: {
    VIEW_PAGE_ACTIVITY_PANEL_TOGGLE: "viewPage.activityPanelToggle",
    NAV_BACK_TO_QUIZ_LANDING_PAGE: "viewPage.navBackToQuizLandingPage",
    QUIZ_RESPONSE_DATA_LOADED: "viewPage.quizResponseDataLoaded",
    RESET_ACTIVITY_PANEL_CONTENTS: "viewPage.resetActivityPanelContents",
    PRESENT_MODE_ACTIVE: "viewPage.presentModeActive",
  },
  ANNOTATION_EVENT: {
    ACTIVATE: "annotationEvent.activate",
  },
  PLAYER_EVENT: {
    LOADED_DATA: "playerEvent.loadeddata",
  },
};

export default videoPlayerEvents;
